import { render, staticRenderFns } from "./VeJwJxrwList.vue?vue&type=template&id=6cfc9602&scoped=true"
import script from "./VeJwJxrwList.vue?vue&type=script&lang=js"
export * from "./VeJwJxrwList.vue?vue&type=script&lang=js"
import style0 from "./VeJwJxrwList.vue?vue&type=style&index=0&id=6cfc9602&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc9602",
  null
  
)

export default component.exports